import React from 'react';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import AttendAchievementLayoutOutput from 'components/organismos/master/attend/AttendAchievementLayoutOutput';

const AttendAchievementOutput: React.FC = () => (
  <SidebarTemplate>
    <AttendAchievementLayoutOutput />
  </SidebarTemplate>
);

export default AttendAchievementOutput;
